import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { ApiResponse } from '../shared/types';

/** Receipt DTO returned by POST /api/v1/order/public/receipt (svc-order). */
export interface PublicReceiptResult {
  shopName: string | null;
  /** Signed https URL, validated server-side. */
  shopLogo: string | null;
  branch: string | null;
  locationAddress: string | null;
  orderNumber: string | null;
  packageName: string | null;
  washType: string | null;
  /** Formatted, e.g. "$25.00". */
  amountPaid: string | null;
  refunded: boolean;
  refundedAmount: string | null;
  /** Label, e.g. "Card". */
  paymentMethod: string | null;
  /** Formatted, e.g. "Sep 11, 2026, 10:35 AM". */
  paidAt: string | null;
}

/**
 * Unauthenticated client for the SMS receipt public API.
 * POST /api/v1/order/public/receipt — load a shop-branded receipt by token.
 */
@Injectable({ providedIn: 'root' })
export class ReceiptPublicService {
  constructor(private readonly api: ApiService) {}

  loadReceipt(token: string): Observable<ApiResponse<PublicReceiptResult>> {
    return this.api.postWithoutAuth<PublicReceiptResult>('order/public/receipt', { token });
  }
}
